import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const generateCarousel = (payload) => api.post("/carousels/generate", payload).then(r => r.data);
export const recreateCarousel = (payload) => api.post("/carousels/recreate", payload).then(r => r.data);
export const listCarousels = () => api.get("/carousels").then(r => r.data);
export const getCarousel = (id) => api.get(`/carousels/${id}`).then(r => r.data);
export const updateCarousel = (id, payload) => api.put(`/carousels/${id}`, payload).then(r => r.data);
export const deleteCarousel = (id) => api.delete(`/carousels/${id}`).then(r => r.data);
export const regenerateSlide = (id, index, prompt) =>
  api.post(`/carousels/${id}/slides/${index}/regenerate`, { prompt: prompt || "" }).then(r => r.data);

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
  });
  return res.data;
};

export const fileUrl = (relativeUrl) => {
  if (!relativeUrl) return "";
  if (relativeUrl.startsWith("http")) return relativeUrl;
  return `${BACKEND_URL}${relativeUrl}`;
};

// Brands (multi)
export const listBrands = () => api.get("/brands").then(r => r.data);
export const createBrand = (payload) => api.post("/brands", payload).then(r => r.data);
export const updateBrand = (id, payload) => api.put(`/brands/${id}`, payload).then(r => r.data);
export const deleteBrand = (id) => api.delete(`/brands/${id}`).then(r => r.data);

// Password
export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then(r => r.data);

// Auth
export const authLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true }).then(r => r.data);
export const authRegister = (email, password, name, lang = "el") =>
  axios.post(`${API}/auth/register`, { email, password, name, lang }, { withCredentials: true }).then(r => r.data);
export const authLogout = () => axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
export const authMe = () => axios.get(`${API}/auth/me`, { withCredentials: true }).then(r => r.data);
export const forgotPassword = (email, lang = "el") =>
  axios.post(`${API}/auth/forgot-password`, { email, lang }).then(r => r.data);
export const resetPassword = (token, new_password) =>
  axios.post(`${API}/auth/reset-password`, { token, new_password }).then(r => r.data);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
